import { IAvailableCandidate } from '@types';
import { IListColumn } from 'components/candidate/CandidatesList/columns';

export type AvailableCandidateColumnId =
  | 'candidate'
  | 'technicalRanking'
  | 'softSkills'
  | 'tt'
  | 'materials'
  | 'availableFrom'
  | 'nextSteps';

export type IAvailableCandidateColumn = IListColumn<
  AvailableCandidateColumnId,
  IAvailableCandidate
>;

export const AvailableCandidateColumns: IAvailableCandidateColumn[] = [
  {
    id: 'candidate',
    label: 'Candidate',
    sortKey: 'name',
    width: '18%',
    align: 'left',
    defaultOn: true,
    alwaysOn: true,
    dropPriority: 0,
  },
  {
    id: 'technicalRanking',
    label: 'Technical ranking',
    sortKey: 'technicalRanking',
    width: '11%',
    align: 'left',
    defaultOn: true,
    dropPriority: 3,
    hasData: (candidate) => Boolean(candidate.ranking?.technicalInterview),
  },
  {
    id: 'softSkills',
    label: 'Soft skills',
    sortKey: 'softSkills',
    width: '9%',
    align: 'left',
    defaultOn: true,
    dropPriority: 5,
    hasData: (candidate) => Boolean(candidate.ranking?.softSkills),
  },
  {
    id: 'tt',
    label: 'TT score, %',
    sortKey: 'testTask',
    width: '8%',
    align: 'left',
    defaultOn: true,
    dropPriority: 2,
    hasData: (candidate) => typeof candidate.testTask.score === 'number',
  },
  {
    id: 'materials',
    label: 'Intro & resume',
    sortKey: null,
    width: '8%',
    align: 'left',
    defaultOn: true,
    dropPriority: 4,
    hasData: (candidate) => candidate.hasVideo || candidate.hasResume,
  },
  {
    id: 'availableFrom',
    label: 'Available from',
    sortKey: 'availableFrom',
    width: '12%',
    align: 'left',
    defaultOn: true,
    dropPriority: 1,
    hasData: (candidate) => candidate.availability.kind !== 'empty',
  },
  {
    id: 'nextSteps',
    label: 'Next steps',
    sortKey: null,
    width: '34%',
    align: 'left',
    defaultOn: true,
    alwaysOn: true,
    dropPriority: 0,
  },
];

export const isAvailableCandidateColumnId = (
  id: string,
): id is AvailableCandidateColumnId =>
  AvailableCandidateColumns.some((column) => column.id === id);
